import { Component, OnInit, NgModule, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxToolbarModule, DxButtonModule } from 'devextreme-angular';
import moment from 'moment';
import { APIConfing } from '../../services/apiconfing.service';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
  standalone: false
})
export class PublicFooterComponent implements OnInit, OnChanges {
  @Input() cmpName: any;
  year: any;
  customerTitle: any;
  isWhiteLabled: any;
  footerLink: any;
  footerText: any;
  footerImg: any;

  constructor() { }

  ngOnInit() {
    this.isWhiteLabled = APIConfing.data.isWhiteLabled;
    this.footerLink = APIConfing.data.footerConfig.footerLink;
    this.footerText = APIConfing.data.footerConfig.footerText;
    this.footerImg = APIConfing.data.footerConfig.footerImg;
    this.year = moment(new Date()).format('YYYY');
  }
  ngOnChanges() {
    if (this.cmpName) {
      this.customerTitle = this.cmpName;
    }
  }

}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    DxToolbarModule
  ],
  declarations: [PublicFooterComponent],
  exports: [PublicFooterComponent]
})
export class PublicFooterModule { }